module.exports = __webpack_public_path__ + "img/logo-zomato.c6d71e1e.png";